import { NgModule} from '@angular/core';
import { HostAliasPipe } from "./host-alias.pipe";
import { CommonModule } from "@angular/common";

@NgModule({
    imports: [
        CommonModule,
    ],
    providers: [
        HostAliasPipe,
    ],
    exports: [
        HostAliasPipe
    ],
    declarations: [
        HostAliasPipe
    ],
})
export class HostAliasPipeModule { }
